// 砍价功能的状态管理
// 🚀 API防抖调用（模块级变量，不污染state）
let debounceTimer = null

const getDefaultState = () => {
    return {
        // 当前选中的砍价
        currentBargain: null,
        // 砍价历史记录
        bargainHistory: [],
        // 砍价im 消息顶部信息
        bargainImMessageTop: null,
        // 砍价盒子列表
        bargainBoxList: [],
        // 用户信息
        bargainUserInfo: {},
        // 折叠的砍价列表
        foldedBargainList: {},
        // 砍价事件数据 - 处理 bargaining-message-status 按钮
        bargainImEvent: null,
        // 砍价tab
        bargainType: 0,
        // 偏移量
        offsetId: 0,
        // 未读消息数量
        bargainUnReadMsgCount: 0,
        // 是否展示砍价会话窗口
        showBargaining: false,
        more: true
    }
}

export const state = () => ({
    ...getDefaultState()
})

export const mutations = {
    // 设置是否展示砍价会话窗口
    SET_SHOW_BARGAINING: (state, show) => {
        state.showBargaining = show
    },
    // 设置当前选中的砍价
    SET_CURRENT_BARGAIN: (state, info) => {
        state.currentBargain = info
    },
    // 设置砍价历史记录
    SET_BARGAIN_HISTORY: (state, list) => {
        state.bargainHistory = list
    },
    // 设置砍价im 消息顶部信息
    SET_BARGAIN_IM_MESSAGE_TOP: (state, info) => {
        state.bargainImMessageTop = info
    },
    // 设置砍价盒子列表
    SET_BARGAIN_BOX_LIST: (state, list) => {
        if (state.offsetId === 0) {
            state.bargainBoxList = list
        } else {
            state.bargainBoxList = [...state.bargainBoxList, ...list]
        }
    },
    // 更新砍价盒子列表
    UPDATE_BARGAIN_BOX_ITEM: (state, item) => {
        const matchedIndex = state.bargainBoxList.findIndex(box => box.goodsNo === item.goodsNo)
        if (matchedIndex !== -1) {
            // 更新已存在的项
            state.bargainBoxList.splice(matchedIndex, 1, { ...item })
        } else {
            // 添加新项到数组开头
            state.bargainBoxList.unshift({ ...item })
        }
    },
    // 设置用户信息
    SET_BARGAIN_USER_INFO: (state, info) => {
        state.bargainUserInfo = info
    },
    // 设置折叠的砍价列表
    SET_FOLDED_BARGAIN_LIST: (state, list) => {
        state.foldedBargainList = list
    },
    // 设置砍价事件数据
    SET_BARGAIN_IM_EVENT: (state, data) => {
        state.bargainImEvent = data
    },
    // 设置砍价tab
    SET_BARGAIN_TYPE: (state, type) => {
        state.bargainType = type
    },
    // 清空指定会话的未读消息数
    CLEAR_BARGAIN_UNREAD_COUNT: (state, sessionId) => {
        if (state.bargainBoxList && Array.isArray(state.bargainBoxList)) {
            state.bargainBoxList.forEach(item => {
                if (item.sessionId === sessionId) {
                    item.unreadMessageCount = 0
                }
            })
        }

        // 同时清空折叠列表中的未读数
        Object.keys(state.foldedBargainList).forEach(goodsNo => {
            if (state.foldedBargainList[goodsNo] && Array.isArray(state.foldedBargainList[goodsNo])) {
                state.foldedBargainList[goodsNo].forEach(item => {
                    if (item.sessionId === sessionId) {
                        item.unreadMessageCount = 0
                    }
                })
            }
        })
    },
    // 设置砍价消息未读数量
    SET_BARGAIN_UNREAD_MESSAGE_COUNT: (state, count) => {
        state.bargainUnReadMsgCount = count
    }
}

export const actions = {
    loadNext({ state, dispatch }) {
        if (!state.more) {
            return
        }
        dispatch('getBargainBoxList')
    },
    updateBargainBoxItem({ commit, state }, item) {
        function isSameMsg(box, item) {
            if (box.goodsNo) {
                return box.goodsNo === item.goodsNo
            }
            return box.sessionId === item.sessionId
        }
        const matchedItem = state.bargainBoxList.find(box => isSameMsg(box, item))
        const data = [item]
        // 存储用户信息到store
            const fetchUserInfo = () => {
                const oppositeUserIds = [...new Set(data.map(item => item.oppositeUserId).filter(Boolean))]

                if (oppositeUserIds.length > 0) {
                    this.$api.findUsers({ action: { userIds: oppositeUserIds } })
                        .then(({ success, data }) => {
                            if (success && data.length) {
                                const userInfo = data.reduce((acc, item) => {
                                    acc[item.id] = item
                                    return acc
                                }, {})
                                commit('SET_BARGAIN_USER_INFO', userInfo)
                            } else {
                                commit('SET_BARGAIN_USER_INFO', {})
                            }
                        })
                }
            }

            // 处理数据
            const processData = () => {
                // 1. 将数据分为买家消息和卖家消息(盒子)
                const buyerMessages = [] // 买家发起的消息
                const sellerBoxes = [] // 卖家的盒子消息

                data.forEach(item => {
                    if (item.isBuyer) {
                        buyerMessages.push(item)
                    } else {
                        sellerBoxes.push(item)
                    }
                })

                // 2. 按goodsNo对卖家盒子消息分组
                const boxGroups = new Map()
                sellerBoxes.forEach(box => {
                    const key = box.goodsNo || `no_goods_${box.sessionId}` // 处理没有goodsNo的情况
                        let count = 1
                        // 如果是卖家消息
                        if (matchedItem && !matchedItem.isBuyer) {
                            // 同一用户消息不加条数
                            if (matchedItem.oppositeUserId === box.oppositeUserId) {
                                count = matchedItem.foldedCount
                            } else {
                                // 不同消息加条数
                                count = matchedItem.foldedCount + 1
                            }
                        }
                        boxGroups.set(key, {
                            items: [box],
                            count,
                            latest: box
                        })
                })

                // 3. 生成最终结果
                const processedData = []

                // 先添加买家消息
                buyerMessages.forEach(item => {
                    processedData.push({
                        ...item,
                        conversationType: 1,
                        isBargain: true,
                        groupType: -1,
                        headImage: item.boxPortrait,
                        name: `发起砍价（${item.title}）`,
                        targetId: item.sessionId,
                        status: 0,
                        workIdentity: 1,
                        isFolded: false, // 买家消息不是盒子
                        latestMessage: {
                            content: {
                                content: item.priceInfo
                            },
                            messageType: 'RC:TxtMsg',
                            sentTime: new Date(item.sentTime.replace(' ', 'T')).getTime()
                        }
                    })
                })

                // 添加卖家盒子消息
                boxGroups.forEach(group => {
                    const box = group.latest
                    processedData.push({
                        ...box,
                        conversationType: 1,
                        isBargain: true,
                        groupType: -1,
                        headImage: box.boxPortrait,
                        name: `收到砍价（${box.title}）`,
                        targetId: box.sessionId,
                        status: 0,
                        workIdentity: 1,
                        isFolded: true, // 所有卖家消息都是盒子
                        foldedCount: group.count, // 盒子数量
                        latestMessage: {
                            content: {
                                content: `${group.count}条出价` // 无论几条都显示"X条出价"
                            },
                            messageType: 'RC:TxtMsg',
                            sentTime: new Date(box.sentTime.replace(' ', 'T')).getTime()
                        }
                    })
                })

                return processedData
            }

            // 执行用户信息获取
            fetchUserInfo()

            // 处理并提交数据
            const processedData = processData()
            commit('UPDATE_BARGAIN_BOX_ITEM', processedData[0])
    },
    // 获取砍价盒子列表
    async getBargainBoxList({ commit, state, dispatch }) {
        try {
            const { success, data = [] } = await this.$api.messageBoxListAPI({
                action: {
                    bargainOrderNo: '',
                    offsetId: state.offsetId,
                    searchType: 0,
                    sessionIds: [],
                    up: true
                }
            })

            if (!success || !data.length) {
                state.offsetId = 0
                commit('SET_BARGAIN_BOX_LIST', [])
                return
            }

            if (data.length === 100) {
                state.offsetId = data[data.length - 1].offsetId
                state.more = true
                // 第一次进来时轮训24小时内的砍价消息
                const item = data[data.length - 1]
                const currentTime = Date.now()
                const sentTime = new Date(item?.sentTime.replace(' ', 'T')).getTime()
                const twentyFourHoursInMs = 24 * 60 * 60 * 1000 // 24小时的毫秒数
                // 只显示24小时内的砍价消息
                const is24Hours = currentTime - sentTime <= twentyFourHoursInMs
                if (is24Hours && sentTime) {
                    dispatch('getBargainBoxList')
                }
            } else {
                state.more = false
            }

            // 处理用户信息获取
            const fetchUserInfo = () => {
                const oppositeUserIds = [...new Set(data.map(item => item.oppositeUserId).filter(Boolean))]

                if (oppositeUserIds.length > 0) {
                    this.$api.findUsers({ action: { userIds: oppositeUserIds } })
                        .then(({ success, data }) => {
                            if (success && data.length) {
                                const userInfo = data.reduce((acc, item) => {
                                    acc[item.id] = item
                                    return acc
                                }, {})
                                commit('SET_BARGAIN_USER_INFO', userInfo)
                            } else {
                                commit('SET_BARGAIN_USER_INFO', {})
                            }
                        })
                }
            }

            // 处理数据
            const processData = () => {
                // 1. 将数据分为买家消息和卖家消息(盒子)
                const buyerMessages = [] // 买家发起的消息
                const sellerBoxes = [] // 卖家的盒子消息

                data.forEach(item => {
                    if (item.isBuyer) {
                        buyerMessages.push(item)
                    } else {
                        sellerBoxes.push(item)
                    }
                })

                // 2. 按goodsNo对卖家盒子消息分组
                const boxGroups = new Map()
                sellerBoxes.forEach(box => {
                    const key = box.goodsNo || `no_goods_${box.sessionId}` // 处理没有goodsNo的情况

                    if (boxGroups.has(key)) {
                        const group = boxGroups.get(key)
                        group.items.push(box)
                        group.count++

                        // 更新最新的盒子(按时间)
                        const boxTime = new Date(box.sentTime.replace(' ', 'T')).getTime()
                        const latestTime = new Date(group.latest.sentTime.replace(' ', 'T')).getTime()
                        if (boxTime > latestTime) {
                            group.latest = box
                        }
                    } else {
                        boxGroups.set(key, {
                            items: [box],
                            count: 1,
                            latest: box
                        })
                    }
                })

                // 3. 生成最终结果
                const processedData = []

                // 先添加买家消息
                buyerMessages.forEach(item => {
                    processedData.push({
                        ...item,
                        conversationType: 1,
                        isBargain: true,
                        groupType: -1,
                        headImage: item.boxPortrait,
                        name: `发起砍价（${item.title}）`,
                        targetId: item.sessionId,
                        status: 0,
                        workIdentity: 1,
                        isFolded: false, // 买家消息不是盒子
                        latestMessage: {
                            content: {
                                content: item.priceInfo
                            },
                            messageType: 'RC:TxtMsg',
                            sentTime: new Date(item.sentTime.replace(' ', 'T')).getTime()
                        }
                    })
                })

                // 添加卖家盒子消息
                boxGroups.forEach(group => {
                    const box = group.latest
                    processedData.push({
                        ...box,
                        conversationType: 1,
                        isBargain: true,
                        groupType: -1,
                        headImage: box.boxPortrait,
                        name: `收到砍价（${box.title}）`,
                        targetId: box.sessionId,
                        status: 0,
                        workIdentity: 1,
                        isFolded: true, // 所有卖家消息都是盒子
                        foldedCount: group.count, // 盒子数量
                        latestMessage: {
                            content: {
                                content: `${group.count}条出价` // 无论几条都显示"X条出价"
                            },
                            messageType: 'RC:TxtMsg',
                            sentTime: new Date(box.sentTime.replace(' ', 'T')).getTime()
                        }
                    })
                })

                return processedData
            }

            // 执行用户信息获取
            fetchUserInfo()

            // 处理并提交数据
            const processedData = processData()
            commit('SET_BARGAIN_BOX_LIST', processedData)

            // 如果已有选中的砍价，自动加载其相关数据
            if (state.currentBargain) {
                dispatch('loadBargainData')
            }
        } catch (err) {
            console.error('获取消息盒子列表失败:', err)
            state.offsetId = 0
            commit('SET_BARGAIN_BOX_LIST', [])
        }
    },

    // 加载砍价会话数据
    async loadBargainData({ commit, state, rootGetters }) {
        const currentBargain = state.currentBargain
        if (!currentBargain || !currentBargain.sessionId) { return }

        try {
            // 获取砍价顶部信息
            const topRes = await this.$api.bargainImMessageTopAPI({
                sessionId: currentBargain.sessionId
            })

            if (!topRes.success || !topRes.data) {
                console.error('获取砍价顶部信息失败')
                return
            }

            // 提交砍价顶部信息
            commit('SET_BARGAIN_IM_MESSAGE_TOP', topRes.data)

            // 获取砍价事件数据
            if (topRes.data && topRes.data.id) {
                try {
                    const eventRes = await this.$api.bargainImEventAPI({ action: { bargainId: topRes.data.id } })

                    if (eventRes.success && eventRes.data) {
                        // 存储砍价事件数据到 store
                        commit('SET_BARGAIN_IM_EVENT', eventRes.data)
                    }
                } catch (error) {
                    console.error('获取砍价事件数据失败:', error)
                }
            }

            // 根据会话状态获取不同的数据
            if (currentBargain.isFolded) {
                // 如果是折叠状态，获取折叠的砍价列表
                if (currentBargain.goodsNo) {
                    try {
                        const boxRes = await this.$api.bargainImMessageBoxDetailsAPI({
                            action: {
                                bargainOrderNo: topRes.data.bargainOrderNo || '',
                                offsetId: 0,
                                searchType: 0,
                                sessionIds: [currentBargain.sessionId],
                                up: true
                            },
                            order: 'DESC',
                            page: 1,
                            pageSize: 100,
                            sort: 'create_time'
                        })

                        if (boxRes.success && boxRes.data && boxRes.data.records) {
                            // 对records先按price从高到低排序，价格相同时按时间排序
                            // const sortedRecords = [...boxRes.data.records].sort((a, b) => {
                            //     // 先按价格从高到低排序
                            //     const priceA = parseFloat(a.price || 0)
                            //     const priceB = parseFloat(b.price || 0)

                            //     if (priceB !== priceA) {
                            //         return priceB - priceA // 价格不同，从高到低排序
                            //     }

                            //     // 价格相同时，按时间排序（假设有sentTime字段）
                            //     const timeA = new Date(a.sentTime?.replace(' ', 'T') || 0).getTime()
                            //     const timeB = new Date(b.sentTime?.replace(' ', 'T') || 0).getTime()
                            //     return timeB - timeA // 时间从新到旧排序
                            // })

                            // const foldedData = {
                            //     [currentBargain.goodsNo]: boxRes.data.records
                            // }
                            // console.log(foldedData, '折叠的砍价列表123123')
                            commit('SET_FOLDED_BARGAIN_LIST', { [currentBargain.goodsNo]: boxRes.data.records })
                        }
                    } catch (error) {
                        console.error('获取折叠砍价列表失败:', error)
                    }
                }
            } else {
                // // 已有历史记录不再重复获取
                // if (state.bargainHistory && state.bargainHistory.length > 0) {
                //     return
                // }

                // 如果是单个会话，获取历史记录
                try {
                    const historyRes = await this.$api.bargainImMessageHistoryAPI({
                        limit: 100,
                        msgIds: [],
                        offsetId: 0,
                        up: true,
                        sessionId: currentBargain.sessionId
                    })

                    if (historyRes.success && historyRes.data) {
                        const processedHistory = Array.isArray(historyRes.data)
                            ? historyRes.data.map(item => {
                                // 处理ex字段，将字符串转换为对象
                                if (item.ex && typeof item.ex === 'string') {
                                    try {
                                        item.ex = JSON.parse(item.ex)
                                    } catch (error) {
                                        console.error('解析ex字段失败:', error)
                                    }
                                }
                                return item
                            })
                            : []

                        commit('SET_BARGAIN_HISTORY', processedHistory)
                        // 获取最后一条对方发送的消息
                        const userinfo = rootGetters['user/userinfo']
                        const lastOpponentMessage = processedHistory
                            .filter(item => item.uid !== userinfo.id) // 过滤出对方发送的消息
                            .sort((a, b) => new Date(b.createTime) - new Date(a.createTime)) // 按发送时间倒序排列
                            .find(item => item) // 获取最新的一条

                        if (lastOpponentMessage) {
                            console.log('最后一条对方发送的消息:', lastOpponentMessage)
                            this.$api.bargainImMessageBatchAckAPI({
                                offsetId: lastOpponentMessage?.offsetId,
                                sessionId: lastOpponentMessage?.sessionId
                            }).then(res => {
                                console.log(res, '批量确认消息已读')
                                // 接口调用成功后，清空当前会话的未读数
                                if (res.success) {
                                    commit('CLEAR_BARGAIN_UNREAD_COUNT', lastOpponentMessage?.sessionId)
                                    // 同时减少总未读数
                                    const currentAllUnreadCount = rootGetters['bargaining/bargainUnReadMsgCount'] || 0
                                    if (currentAllUnreadCount > 0) {
                                        commit('SET_BARGAIN_UNREAD_MESSAGE_COUNT', currentAllUnreadCount - 1)
                                    }
                                }
                            })

                            // 这里可以根据需要处理最后一条对方消息的逻辑
                        }
                    }
                } catch (error) {
                    console.error('获取砍价历史记录失败:', error)
                }
            }
        } catch (error) {
            console.error('加载砍价数据失败:', error)
        }
    },
    // 安全的防抖调用，获取最新未读数量
    getBargainUnReadMessageCount({ commit, state }) {
        // 清除之前的定时器
        if (debounceTimer) {
            clearTimeout(debounceTimer)
            console.log('🚀 [防抖] 清除之前的调用，等待最新调用')
        }

        // 设置新的定时器，2秒后执行
        debounceTimer = setTimeout(async () => {
            try {
                console.log('🚀 [防抖API] 执行最后一次调用，获取最新未读数')

                const res = await this.$api.getUnReadMessageCountAPI()

                if (res.success) {
                    commit('SET_BARGAIN_UNREAD_MESSAGE_COUNT', res.data)
                    console.log('🚀 [API成功] 最新未读数:', res.data)
                } else {
                    console.warn('⚠️ [API警告] 获取未读数失败:', res.info)
                }
            } catch (error) {
                console.error('❌ [防抖API异常]:', error)
            } finally {
                // 确保清理定时器引用
                debounceTimer = null
            }
        }, 2000) // 2秒防抖延迟

        console.log('🚀 [防抖] 2秒后将获取最新未读数')

        // 立即返回成功，避免Promise泄漏
        return Promise.resolve({ success: true, debounced: true })
    },

    // 🛡️ 安全清理：页面卸载时清理定时器
    clearBargainDebounceTimer() {
        if (debounceTimer) {
            clearTimeout(debounceTimer)
            debounceTimer = null
            console.log('🛡️ [安全清理] 已清理防抖定时器')
        }
    }
}

export const getters = {
    // 是否展示砍价会话窗口
    showBargaining: state => state.showBargaining,
    currentBargain: state => state.currentBargain,
    bargainUnReadMsgCount: state => state.bargainUnReadMsgCount,
    bargainHistory: state => state.bargainHistory,
    bargainImMessageTop: state => state.bargainImMessageTop,
    bargainBoxList: state => state.bargainBoxList,
    bargainUserInfo: state => state.bargainUserInfo,
    foldedBargainList: state => state.foldedBargainList,
    bargainImEvent: state => state.bargainImEvent,
    bargainType: state => state.bargainType,
    // 砍价按钮类型映射
    bargainButtonMap: () => {
        return {
            // 买家按钮
            INITIATE_BARGAIN: { text: '发起砍价', type: 'buyer' },
            UPDATE_PRICE: { text: '修改出价', type: 'buyer' },
            JUST_ONE_SENTENCE: { text: '稍一句话', type: 'buyer' },
            BUYER_COUNTER_OFFER: { text: '买家还价', type: 'buyer' },
            BUY_NOW: { text: '立即购买', type: 'buyer' },
            SELLER_ORDER_NO_PAY: { text: '买家下单未支付', type: 'buyer' },

            // 卖家按钮
            SELLER_COUNTER_OFFER: { text: '卖家还价', type: 'seller' },
            SELLER_REJECT: { text: '卖家拒绝', type: 'seller' },
            SELLER_AGREE: { text: '卖家同意', type: 'seller' },
            SELLER_AUTO_COUNTER_OFFER: { text: '卖家自动还价', type: 'seller' },
            SELLER_AUTO_REJECT: { text: '卖家自动拒绝', type: 'seller' },
            SELLER_AUTO_AGREE: { text: '卖家自动同意', type: 'seller' }
        }
    },

    // 获取买家可用按钮列表
    buyerButtons: (state, getters) => {
        if (!state.bargainImEvent || !state.bargainImEvent.buyerEvents) {
            return []
        }

        return state.bargainImEvent.buyerEvents.map(eventType => {
            const buttonInfo = getters.bargainButtonMap[eventType] || { text: eventType, type: 'buyer' }
            return {
                ...buttonInfo,
                eventType
            }
        })
    },

    // 获取卖家可用按钮列表
    sellerButtons: (state, getters) => {
        if (!state.bargainImEvent || !state.bargainImEvent.sellerEvents) {
            return []
        }

        return state.bargainImEvent.sellerEvents.map(eventType => {
            const buttonInfo = getters.bargainButtonMap[eventType] || { text: eventType, type: 'seller' }
            return {
                ...buttonInfo,
                eventType
            }
        })
    },

    // 获取当前轮次
    currentRound: state => {
        return state.bargainImEvent?.round || 0
    }
}
